import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { CorporateProfileService } from '@/api/services/masterService'; // Adjust with the actual path to your service


// Define the payload for the update
interface FileType {
  Id: string;
  Description: string;
  File: File;
  FileName: string;
}



// Define the initial state of the upload slice
interface UploadState {
  file: FileType |null;
  loading: boolean;
  error: string | null;
}

const initialState: UploadState = {
  file: null,       
  loading: false, 
  error: null,    
};

// Create the async thunk for updating upload data
export const updateUpload = createAsyncThunk(
  'upload/updateUpload',
  async (payload: FormData, { rejectWithValue }) => {
    try {
      const response = await CorporateProfileService.updateUpload(payload);
      
      return response;
    } catch (error:any) {
      return rejectWithValue(error.message || 'Failed to update upload');
    }
  }
);

// Create the slice that includes reducers and handles the async thunk
const CorporateFileUploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // Handle the 'pending' state of the async thunk
      .addCase(updateUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // Handle the 'fulfilled' state of the async thunk
      .addCase(updateUpload.fulfilled, (state, action: PayloadAction<FileType>) => {
        state.loading = false;
        state.file = action.payload;
      })
      // Handle the 'rejected' state of the async thunk
      .addCase(updateUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Failed to update upload';
      });
  },
});

export default CorporateFileUploadSlice.reducer;
